
import axios from 'axios'


import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import XHeader from "vux/src/components/x-header/index";

export default {
name: 'FindDetail',
components: {XHeader, XButton, XDialog,Toast},
data () {
return {
mobile: '',
termId: '',
showDialog: false
}
},
methods: {
clickToFind: function () {
let param = new URLSearchParams()
param.append('mobile', this.mobile)
param.append('termId', this.termId)
axios.post('http://student.hmifo.com/admin/m/login', param).then((r) => {
console.log(r)
sessionStorage.setItem('mobile', r.data.mobile)
sessionStorage.setItem('termId', r.data.termId)
sessionStorage.setItem('hrReason', r.data.hrReason)
if (r.data.state) {

axios.post('http://student.hmifo.com/admin/application/selectAuthState?mobile' + r.data.mobile, param).then((d) => {
console.log(d)
if (d.data.state === '等待审核') {
this.$router.push({path: '/OnCheck'})
} else if (d.data.state === '审核通过') {
this.$router.push({path: '/SuccessCheck'})

} else if (d.data.state === '审核未通过') {
this.$router.push({path: '/FailCheck'})
} else if ( d.data.code === 1){
this.showDialog = true


}
})
}else {
this.$vux.toast.text('登录失败')
}
}).catch((error) => {


console.log(error)
})
}
}
}




// WEBPACK FOOTER //
// ./src/components/FindDetail.vue